/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RealizedDimensionDelta
 */
export interface RealizedDimensionDelta {
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionDelta
     */
    dimensionKey: string;
    /**
     * 
     * @type {number}
     * @memberof RealizedDimensionDelta
     */
    realizedDelta: number;
    /**
     * 
     * @type {string}
     * @memberof RealizedDimensionDelta
     */
    notes?: string;
}

/**
 * Check if a given object implements the RealizedDimensionDelta interface.
 */
export function instanceOfRealizedDimensionDelta(value: object): value is RealizedDimensionDelta {
    if (!('dimensionKey' in value) || value['dimensionKey'] === undefined) return false;
    if (!('realizedDelta' in value) || value['realizedDelta'] === undefined) return false;
    return true;
}

export function RealizedDimensionDeltaFromJSON(json: any): RealizedDimensionDelta {
    return RealizedDimensionDeltaFromJSONTyped(json, false);
}

export function RealizedDimensionDeltaFromJSONTyped(json: any, ignoreDiscriminator: boolean): RealizedDimensionDelta {
    if (json == null) {
        return json;
    }
    return {
        
        'dimensionKey': json['dimensionKey'],
        'realizedDelta': json['realizedDelta'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function RealizedDimensionDeltaToJSON(json: any): RealizedDimensionDelta {
    return RealizedDimensionDeltaToJSONTyped(json, false);
}

export function RealizedDimensionDeltaToJSONTyped(value?: RealizedDimensionDelta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimensionKey': value['dimensionKey'],
        'realizedDelta': value['realizedDelta'],
        'notes': value['notes'],
    };
}

